import {
  Autocomplete,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const BookingDetailsFields = ({
  t,
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  model,
  date,
  onDateChange,
  time,
  onTimeChange,
  dateEnd,
  onDateEndChange,
  timeEnd,
  onTimeEndChange,
  countries,
  country,
  onCountryChange,
  tours,
  tour,
  onTourChange,
  fieldErrors = {},
  clearFieldError = () => {},
}) => {
  const today = dayjs().startOf("day");

  return (
    <>
    <Grid item xs={12} sm={6}>
      <TextField
        value={values.persons}
        fullWidth
        type="number"
        label={t("persons")}
        onBlur={handleBlur}
        onChange={(event) => {
          clearFieldError("persons");
          handleChange(event);
        }}
        name="persons"
        error={(!!touched.persons && !!errors.persons) || !!fieldErrors.persons}
        helperText={
          fieldErrors.persons
            ? "Ingrese la cantidad de personas"
            : touched.persons && errors.persons
        }
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth error={!!fieldErrors.vehicle}>
        <InputLabel>{t("vehicle")}</InputLabel>
        <Select
          value={values.vehicle}
          id="vehicle"
          name="vehicle"
          label={t("vehicle")}
          onChange={(event) => {
            clearFieldError("vehicle");
            handleChange(event);
          }}
          error={(!!touched.vehicle && !!errors.vehicle) || !!fieldErrors.vehicle}
        >
          {model.map((modelItem, index) => (
            <MenuItem key={index} value={modelItem.id}>
              {t(modelItem.name)}
            </MenuItem>
          ))}
        </Select>
        {!!fieldErrors.vehicle || (!!touched.vehicle && !!errors.vehicle) ? (
          <FormHelperText> Seleccione un Vehiculo </FormHelperText>
        ) : (
          <></>
        )}
      </FormControl>
    </Grid>

    <Grid
      item
      xs={12}
      sm={values.booking === 3 ? 4 : 6}
      md={values.booking === 3 ? 4 : 6}
    >
      <FormControl fullWidth error={!!fieldErrors.booking}>
        <InputLabel>{t("SOLICITAR")}</InputLabel>
        <Select
          value={values.booking}
          id="booking"
          name="booking"
          label={t("SOLICITAR")}
          onChange={(event) => {
            clearFieldError("booking");
            clearFieldError("date");
            clearFieldError("time");
            clearFieldError("dateEnd");
            clearFieldError("timeEnd");
            clearFieldError("country");
            clearFieldError("tour");
            handleChange(event);
          }}
        >
          <MenuItem value="" disabled>
            Seleccione una Opcion
          </MenuItem>
          <MenuItem value={1}>{t("now")}</MenuItem>
          <MenuItem value={2}>{t("later")}(reservas)</MenuItem>
          <MenuItem value={3}>{t("perHours")}</MenuItem>
          <MenuItem value={4}>{t("Tour")}</MenuItem>
          <MenuItem value={5}>{t("Cotizacion")}</MenuItem>
        </Select>
        {fieldErrors.booking && (
          <FormHelperText>Seleccione una Opcion</FormHelperText>
        )}
      </FormControl>
    </Grid>

    <Grid
      item
      xs={6}
      sm={values.booking === 3 ? 2 : 3}
      sx={{
        display: {
          xs: values.booking && values.booking !== 1 ? "block" : "none",
          md: values.booking && values.booking !== 1 ? "block" : "none",
        },
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={2}>
          <MobileDatePicker
            label={values.booking === 3 ? t("startDate") : t("date")}
            inputFormat="DD/MM/YYYY"
            name="date"
            value={date}
            minDate={today}
            onChange={onDateChange}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!fieldErrors.date}
                helperText={fieldErrors.date ? "Seleccione la fecha" : ""}
              />
            )}
          />
        </Stack>
      </LocalizationProvider>
    </Grid>

    <Grid
      item
      xs={6}
      sm={values.booking === 3 ? 2 : 3}
      sx={{
        display: {
          xs: values.booking && values.booking !== 1 ? "block" : "none",
          md: values.booking && values.booking !== 1 ? "block" : "none",
        },
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3}>
          <MobileTimePicker
            label={values.booking === 3 ? t("startTime") : t("time")}
            value={time}
            name="time"
            onChange={onTimeChange}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!fieldErrors.time}
                helperText={fieldErrors.time ? "Seleccione la hora" : ""}
              />
            )}
          />
        </Stack>
      </LocalizationProvider>
    </Grid>

    <Grid
      item
      xs={6}
      sm={2}
      sx={{
        display: {
          xs: values.booking === 3 ? "block" : "none",
          md: values.booking === 3 ? "block" : "none",
        },
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={2}>
          <MobileDatePicker
            label={t("endDate")}
            inputFormat="DD/MM/YYYY"
            name="dateEnd"
            value={dateEnd}
            minDate={today}
            onChange={onDateEndChange}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!fieldErrors.dateEnd}
                helperText={fieldErrors.dateEnd ? "Seleccione fecha final" : ""}
              />
            )}
          />
        </Stack>
      </LocalizationProvider>
    </Grid>

    <Grid
      item
      xs={6}
      sm={2}
      sx={{
        display: {
          xs: values.booking === 3 ? "block" : "none",
          md: values.booking === 3 ? "block" : "none",
        },
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3}>
          <MobileTimePicker
            label={t("endTime")}
            value={timeEnd}
            name="timeEnd"
            onChange={onTimeEndChange}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!fieldErrors.timeEnd}
                helperText={fieldErrors.timeEnd ? "Seleccione hora final" : ""}
              />
            )}
          />
        </Stack>
      </LocalizationProvider>
    </Grid>

    {countries && (
      <Grid
        item
        xs={12}
        sm={4}
        sx={{
          display: {
            xs: values.booking === 4 ? "block" : "none",
            md: values.booking === 4 ? "block" : "none",
          },
        }}
      >
        <Autocomplete
          value={country}
          disablePortal
          id="select-origin"
          onChange={(e, newValue) => {
            onCountryChange(newValue);
          }}
          options={countries}
          getOptionLabel={(option) => `${option.name}`}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("PAIS")}
              error={!!fieldErrors.country}
              helperText={fieldErrors.country ? "Seleccione el pais" : ""}
            />
          )}
        />
      </Grid>
    )}

    {tours.length > 0 && (
      <Grid
        item
        xs={12}
        sm={8}
        sx={{
          display: {
            xs: values.booking === 4 ? "block" : "none",
            md: values.booking === 4 ? "block" : "none",
          },
        }}
      >
        <Grid container sx={{ alignItems: "center" }}>
          <Grid xs={11}>
            <Autocomplete
              value={tour}
              disablePortal
              id="select-origin"
              onChange={(e, newValue) => {
                onTourChange(newValue);
              }}
              options={tours}
              getOptionLabel={(option) => `${option.code} ${option.title}`}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("TOUR")}
                  error={!!fieldErrors.tour}
                  helperText={fieldErrors.tour ? "Seleccione el tour" : ""}
                />
              )}
            />
          </Grid>
          {tour && (
            <Grid xs={1} padding={1}>
              <InfoOutlinedIcon
                sx={{
                  backgroundColor: "primary.main",
                  color: "white",
                  borderRadius: "5px",
                  padding: "3px",
                  cursor: "pointer",
                  height: "100%",
                  width: "100%",
                }}
                onClick={() => {
                  const base = `https://tours.taximundo.com`;
                  window.open(
                    `${base}/${
                      tour.language_abbreviation
                    }/${tour.country_name.toLowerCase()}/${tour.city_name.toLowerCase()}/${
                      tour.url_activity
                    }`,
                    "_blank",
                  );
                }}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    )}

    <Grid item xs={12}>
      <TextField
        value={values.note}
        fullWidth
        type="text"
        label={t("notes")}
        onBlur={handleBlur}
        onChange={handleChange}
        name="note"
        error={!!touched.note && !!errors.note}
        helperText={touched.note && errors.note}
      />
    </Grid>
    </>
  );
};

export default BookingDetailsFields;
